import { CreateNotebookResult } from '../api/v2';

export enum NotebookEntitiesTypes {
  Course = 'course',
  Workgroup = 'workgroup',
}

export interface MissingNotebookResult {
  groupId: string;
  displayName: string;
  type: NotebookEntitiesTypes;
  jobId: string | null;
}

export interface MissingNotebookCreateResult {
  entityId: string;
  displayName: string;
  entityType: NotebookEntitiesTypes;
  creationState: CreateNotebookResult['creationState'];
  errorCode: CreateNotebookResult['errorCode'];
  jobId: CreateNotebookResult['jobId'];
}
